
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanCross as ObiBuoyCanCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-cross.js';
 
 
 

 
 export const ObiBuoyCanCross = createComponent({
   react: React,
   tagName: 'obi-buoy-can-cross',
   elementClass: ObiBuoyCanCrossElement,
   events: {
     
   }
  });
 
 